import {
  CheckCircleOutlined, EditOutlined, StopOutlined,
  CopyOutlined, EyeOutlined, LockOutlined,
} from "@ant-design/icons";
import { PageHeader, Popconfirm, Tag, Tooltip, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, SegmentedItem, TableItemDinamico } from "../../../Components/Items";
import moment from "moment";
import "moment/locale/es";
import AgregarTipoPrestacion from "./AgregarTipoPrestacion/AgregarTipoPrestacion";
import EditarTipoPrestacion from "./EditarTipoPrestacion/EditarTipoPrestacion";
import VerTipoPrestacion from "./VerTipoPrestacion/VerTipoPrestacion";

moment.locale("es");

class TiposPrestaciones extends Component {
  tableRef = null;
  state = {
    todosTiposPrestaciones: [],
    loading: false,
    valor: 1,
    modalAgregar: false,
    modalEditar: false,
    modalEditarId: null,
    modalVer: false,
    modalVerId: null,
  };

  consultarTiposPrestaciones(params) {
    this.setState({ loading: true });
    axios
      .post("tiposPrestaciones/selectTodasTiposPrestaciones", { empresaId: this.props.empresaId, ...params }, { headers: this.props.headersToken })
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success !== 2) {
          this.setState({ todosTiposPrestaciones: [] });
        } else {
          this.setState({ todosTiposPrestaciones: res.data.data, totalRecords: res.data.totalRecords || 0 });
        }
      });
  }

  duplicar(id) {
    this.setState({ loading: true });
    axios
      .post("tiposPrestaciones/duplicarTipoPrestacion", { tipoPrestacionId: id, empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) message.success("Tipo de prestación duplicado exitosamente");
        else message.error("No se pudo duplicar");
        if (this.tableRef) this.tableRef.updateExternalFilters({ valor: this.state.valor });
      });
  }

  deshabilitar(id) {
    axios
      .post("tiposPrestaciones/deshabilitarTipoPrestacion", { tipoPrestacionId: id, empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) message.success("Tipo de prestación deshabilitado");
        else message.error("No se pudo deshabilitar");
        if (this.tableRef) this.tableRef.updateExternalFilters({ valor: this.state.valor });
      });
  }

  habilitar(id) {
    axios
      .post("tiposPrestaciones/habilitarTipoPrestacion", { tipoPrestacionId: id, empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) message.success("Tipo de prestación habilitado");
        else message.error("No se pudo habilitar");
        if (this.tableRef) this.tableRef.updateExternalFilters({ valor: this.state.valor });
      });
  }

  agregar() { this.setState({ modalAgregar: true }); }
  cerrarAgregar() {
    this.setState({ modalAgregar: false });
    this.tableRef.updateExternalFilters({ valor: this.state.valor });
  }

  editar(id) { this.setState({ modalEditar: true, modalEditarId: id }); }
  cerrarEditar() {
    this.setState({ modalEditar: false });
    this.tableRef.updateExternalFilters({ valor: this.state.valor });
  }

  ver(id) { this.setState({ modalVer: true, modalVerId: id }); }
  cerrarVer() { this.setState({ modalVer: false, modalVerId: null }); }

  render() {
    const columns = [
      {
        title: "Número",
        dataIndex: "numero",
        key: "numero",
        buscar: "serieNumero",
        render: (value, record) => `${record.serie} - ${record.numero}`,
        width: "6%",
      },
      {
        title: "Nombre",
        dataIndex: "nombre",
        key: "nombre",
        buscar: "nombre",
        width: "20%",
        render: (value, record) => (
          <span>
            {value}
            {record.esSistema && (
              <Tooltip title="Tabla de sistema — solo lectura">
                <LockOutlined style={{ marginLeft: 6, color: "#faad14" }} />
              </Tooltip>
            )}
          </span>
        ),
      },
      {
        title: "Nombre Fórmula",
        dataIndex: "nombreFormula",
        key: "nombreFormula",
        width: "12%",
        render: (value) => value ? <Tag style={{ fontFamily: "monospace" }}>{value}</Tag> : "—",
      },
      {
        title: "Ejercicio",
        dataIndex: "ejercicio",
        key: "ejercicio",
        width: "6%",
      },
      {
        title: "Vigencia",
        key: "vigencia",
        width: "13%",
        render: (_, record) => {
          const ini = record.fechaInicioVigencia ? moment(record.fechaInicioVigencia).format("DD/MMM/YYYY") : null;
          const fin = record.fechaFinVigencia ? moment(record.fechaFinVigencia).format("DD/MMM/YYYY") : null;
          if (!ini && !fin) return "—";
          return `${ini || "?"} — ${fin || "?"}`;
        },
      },
      {
        title: "Filas",
        dataIndex: "totalFilas",
        key: "totalFilas",
        width: "5%",
        render: (value) => <Tag>{value}</Tag>,
      },
      {
        title: "Origen",
        dataIndex: "esSistema",
        key: "esSistema",
        width: "7%",
        render: (value) => value ? <Tag color="gold">Sistema</Tag> : <Tag color="blue">Empresa</Tag>,
      },
      {
        title: "Estado",
        dataIndex: "estado",
        key: "estado",
        width: "7%",
        render: (value, record) => {
          if (record.esSistema) return <Tag color="gold">Sistema</Tag>;
          if (value === 1) return <Tag color="green">Activo</Tag>;
          if (value === 2) return <Tag color="orange">Deshabilitado</Tag>;
          return "—";
        },
      },
      {
        title: "Acción",
        key: "accion",
        width: "12%",
        render: (_, record) => {
          const buttons = [];

          buttons.push(
            <Tooltip key={`ver-${record._id}`} title="Ver" placement="top"
              overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}>
              <ButtonItem type="default" size="small" icon={<EyeOutlined />}
                onClick={() => this.ver(record._id)} />
            </Tooltip>
          );

          buttons.push(
            <Popconfirm key={`dup-${record._id}`} title="¿Duplicar para tu empresa?"
              onConfirm={() => this.duplicar(record._id)} okText="Sí" cancelText="No">
              <Tooltip title="Duplicar" placement="top"
                overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}>
                <ButtonItem type="default" size="small" icon={<CopyOutlined />} />
              </Tooltip>
            </Popconfirm>
          );

          if (!record.esSistema) {
            buttons.push(
              <Tooltip key={`editar-${record._id}`} title="Editar" placement="top"
                overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}>
                <ButtonItem type="default" size="small" cyan icon={<EditOutlined />}
                  onClick={() => this.editar(record._id)} />
              </Tooltip>
            );

            if (record.estado === 1) {
              buttons.push(
                <Popconfirm key={`des-${record._id}`} title="¿Deshabilitar?"
                  onConfirm={() => this.deshabilitar(record._id)} okText="Sí" cancelText="No">
                  <Tooltip title="Deshabilitar" placement="top"
                    overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}>
                    <ButtonItem type="default" size="small" lima icon={<CheckCircleOutlined />} />
                  </Tooltip>
                </Popconfirm>
              );
            } else {
              buttons.push(
                <Popconfirm key={`hab-${record._id}`} title="¿Habilitar?"
                  onConfirm={() => this.habilitar(record._id)} okText="Sí" cancelText="No">
                  <Tooltip title="Habilitar" placement="top"
                    overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}>
                    <ButtonItem type="default" size="small" rojo icon={<StopOutlined />} />
                  </Tooltip>
                </Popconfirm>
              );
            }
          }

          return <div className="acciones-container">{buttons}</div>;
        },
      },
    ];

    return (
      <>
        <PageHeader
          title="Tipos de Prestaciones"
          style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
          extra={
            <>
              {window.innerWidth > 1000 && (
                <SegmentedItem
                  options={[{ label: "Vigente", value: 1 }, { label: "Deshabilitado", value: 2 }, { label: "Todos", value: 3 }]}
                  onChange={(value) => {
                    if (this.tableRef) this.tableRef.updateExternalFilters({ valor: value, textoFiltro: this.state.textoFiltro });
                    this.setState({ valor: value });
                  }}
                  value={this.state.valor}
                />
              )}
              <ButtonItem type="primary" onClick={this.agregar.bind(this)}>
                Agregar Tipo de Prestación
              </ButtonItem>
            </>
          }
        />
        <TableItemDinamico
          ref={(ref) => (this.tableRef = ref)}
          onRef={(ref) => (this.tableRef = ref)}
          totalRecords={this.state.totalRecords}
          loading={this.state.loading}
          onFetchData={this.consultarTiposPrestaciones.bind(this)}
          anadirValorFiltro={this.state.valor}
          size="small"
          onlyMineFilter
          dataSource={this.state.todosTiposPrestaciones}
          columns={columns}
          scroll={{ x: "max-content" }}
          filterStorageKey={"tiposPrestaciones" + this.props.empresaId}
          onRow={(record) => ({
            onDoubleClick: () => record.esSistema ? this.ver(record._id) : this.editar(record._id),
          })}
          setValor={(valor) => this.setState({ valor })}
          valorDefault={1}
        />
        <AgregarTipoPrestacion
          visible={this.state.modalAgregar}
          cerrarAgregarTipoPrestacion={this.cerrarAgregar.bind(this)}
        />
        <EditarTipoPrestacion
          visible={this.state.modalEditar}
          tipoPrestacionId={this.state.modalEditarId}
          cerrarEditarTipoPrestacion={this.cerrarEditar.bind(this)}
        />
        <VerTipoPrestacion
          visible={this.state.modalVer}
          tipoPrestacionId={this.state.modalVerId}
          cerrarVerTipoPrestacion={this.cerrarVer.bind(this)}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(TiposPrestaciones);